const translationsElement = document.getElementById('isark-review-translations');
if (translationsElement) {
  const words = JSON.parse(translationsElement.textContent);
  const interfaceText = words.interface || {};
  const translateInterface = () => {
    const modal = document.querySelector('.jdgm-write-review-modal');
    if (!modal) return;
    const selectors = '.jdgm-write-review-modal__title, .jdgm-write-review-modal__intro, .jdgm-write-review-modal__field-label, .jdgm-write-review-modal__field-help, .jdgm-write-review-modal__checkbox-text, .jdgm-write-review-modal__nav-btn';
    for (const element of modal.querySelectorAll(selectors)) {
      for (const node of element.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && interfaceText[node.textContent.trim()]) node.textContent = interfaceText[node.textContent.trim()];
      }
    }
    for (const element of [modal, ...modal.querySelectorAll('[aria-label], [placeholder], [title]')]) {
      for (const attribute of ['aria-label', 'placeholder', 'title']) {
        const source = element.getAttribute(attribute);
        if (interfaceText[source]) element.setAttribute(attribute, interfaceText[source]);
      }
    }
  };
  const update = () => {
    const widgets = document.querySelectorAll('#judgeme_product_reviews, #IsarkAllReviews');
    if (!widgets.length) return;
    translateInterface();
    for (const widget of widgets) {
      widget.tabIndex = -1;
      const replace = (selector, text) => {
        if (!text) return;
        for (const element of widget.querySelectorAll(selector)) {
          if (element.childElementCount === 0 && element.textContent.trim() !== text) element.textContent = text;
        }
      };
      replace('.jm-review-widget-minimal-header__title, .jdgm-rev-widg__title', words.heading);
      replace('[data-testid="write-review-button"], .jdgm-write-rev-link', words.write);
      replace('.jm-sort-filter > label, .jdgm-sort-dropdown-label', words.sort);
      replace('.jm-verified-buyer-badge__text', words.verified);
      replace('.jdgm-rev__prod-link-prefix', words.about);
      replace('.jdgm-gallery-title', words.customer_media);
      for (const element of widget.querySelectorAll('.jdgm-rev[data-verified-buyer="true"] .jdgm-rev__buyer-badge')) {
        element.dataset.isarkLabel = words.verified;
      }
      const optionKeys = { created_at: 'recent', 'most-recent': 'recent', highest_rating: 'highest', 'highest-rating': 'highest', lowest_rating: 'lowest', 'lowest-rating': 'lowest', with_pictures: 'pictures', 'with-pictures': 'pictures', pictures_first: 'pictures_first', 'pictures-first': 'pictures_first', videos_first: 'videos_first', 'videos-first': 'videos_first', most_helpful: 'helpful', 'most-helpful': 'helpful' };
      for (const [value, key] of Object.entries(optionKeys)) replace(`.jdgm-sort-dropdown option[value="${value}"]`, words[key]);
      for (const element of widget.querySelectorAll('.jm-average-rating-display .jm-text, .jdgm-rev-widg__summary-text, .jdgm-all-reviews__summary-text')) {
        for (const node of element.childNodes) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          const current = node.textContent.trim();
          const match = current.match(/^(?:Based on\s+)?(\d+)\s+(?:customer\s+)?reviews?$/i);
          if (match) node.textContent = (Number(match[1]) === 1 ? words.one : words.many).replace('[count]', match[1]);
          else if (current === 'Be the first to write a review') node.textContent = words.empty;
        }
      }
      for (const element of widget.querySelectorAll('.jdgm-all-reviews__summary-average')) {
        const match = element.textContent.trim().match(/^([\d.]+)\s+out of 5$/i);
        if (match) element.textContent = words.rating.replace('[rating]', Number(match[1]).toLocaleString(words.locale, { minimumFractionDigits: 1, maximumFractionDigits: 2 }));
      }
      for (const element of widget.querySelectorAll('.jdgm-rev__timestamp[data-content]')) {
        const match = element.dataset.content.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!match) continue;
        const text = /^(nb|nn|no)(-|$)/i.test(words.locale) ? `${match[3]}.${match[2]}.${match[1]}` : new Intl.DateTimeFormat(words.locale, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]))));
        if (element.textContent !== text) element.textContent = text;
      }
      for (const element of widget.querySelectorAll('.jdgm-rev__author')) {
        if (element.childElementCount === 0 && element.textContent.trim() === 'Anonymous' && words.anonymous !== 'Anonymous') element.textContent = words.anonymous;
      }
      for (const element of widget.querySelectorAll('.jdgm-rev__pic-img')) {
        if (element.alt === 'User picture') element.alt = words.customer_picture;
      }
    }
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      observer.disconnect();
      update();
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
  });
  update();
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', () => {
    update();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
}

